import { RootState } from '../store';
import { IWhitelistState } from '../reducers/whitelistSlice';

export const selectWhitelist = (state: RootState): IWhitelistState =>
  state.whitelist;
